// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1WeL3","inner":"Form_inner__53fXX","range":"Form_range__tAeU3","name":"Form_name__2ObYm","actions":"Form_actions__2jB2v"};